import { PRESUPUESTADOR_SET_CUOTA_MONTO } from './constants'
import { validateCapMaxFinanciacion } from './BFFUtils'


export function setCuotaMonto({ cuotasAfinanciar, montoAfinanciar, isFee, selectedLineaFinanciera }) {

  return (dispatch, getState)=>{
    const { presupuestador } = getState()
    let isFeeAux = presupuestador.isFee

    if(isFee) {
      isFeeAux = isFee
    }
    const {maxCap, cuotasAfinanciar: cuotasAfinanciarCalculada} = validateCapMaxFinanciacion(
      presupuestador.lineasFinancieras,
      selectedLineaFinanciera || presupuestador.credit_line_id,
      cuotasAfinanciar,
      presupuestador.nuevo?.bonification,
      presupuestador?.nuevo?.reference_price,
      presupuestador?.nuevo?.net_sale_price,
      presupuestador.special_discount,
      presupuestador?.nuevo?.nuevo
    )
    

    dispatch ({
      type: PRESUPUESTADOR_SET_CUOTA_MONTO,
      data: {
        cuotasAfinanciar: cuotasAfinanciarCalculada,
        montoAfinanciar,
        isFee: isFeeAux,
        maxCap
      },
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SET_CUOTA_MONTO:
      const { cuotasAfinanciar, montoAfinanciar, isFee, maxCap } = action.data
      return {
        ...state,
        cuotasAfinanciar: cuotasAfinanciar === 0 ? 0 : cuotasAfinanciar || state.cuotasAfinanciar,
        montoAfinanciar: montoAfinanciar === 0 ? 0 : montoAfinanciar || state.montoAfinanciar,
        isFee,
        maxCap: maxCap || state.maxCap
      }

    default:
      return state
  }
}